import { onMounted, onUnmounted, ref } from 'vue';

export const useNumberOfVisibleDays = () => {
    const numberOfVisibleDays = ref(5);

    const updateVisibleDays = () => {
        if (window.innerWidth < 768) {
            numberOfVisibleDays.value = 3;
        } else {
            numberOfVisibleDays.value = 5;
        }
    };

    onMounted(() => {
        updateVisibleDays();
        window.addEventListener('resize', updateVisibleDays);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateVisibleDays);
    });

    return {
        numberOfVisibleDays,
    };
};
